import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdminMaintenanceTable from "../../features/admin/AdminMaintenanceTable";
import AdvancedSearch from "../../features/advancedsearch/AdvancedSearch";
import Dashboard from "../../features/dashboard/Dashboard";
import Homepage from '../../features/landingpage/Homepage';
import OrderDetail from "../../features/orderdetail/OrderDetail";
import OrderRequestList from "../../features/orderlist/OrderRequestList";
import OrderSummary from "../../features/ordersummary/OrderSummary";
import Logout from "../features/Logout";
import NewsTable from "./AdminNewsTable";
export default function RouterSetup() {
    return(
            <BrowserRouter>
                <Routes>
                    <Route index path="/home" element={<Homepage/>}/>
                    <Route exact path="/" element={<Navigate to="/home" />}/>
                    <Route path="dashboard" element={<Dashboard/>}/>
                    <Route path="newstable" element={<NewsTable/>}/>
                    <Route path="maintenancetable" element={<AdminMaintenanceTable/>}/>
                    <Route path="ordersummary" element={<OrderSummary/>}/>
                    <Route path="advancedsearch" element={<AdvancedSearch/>}/>
                    <Route path="logout" element={<Logout/>}/>
                    <Route path="orderdetail" element={<OrderDetail/>}/>
                    <Route path="orderrequestlist" element={<OrderRequestList/>}/>
                </Routes>
            </BrowserRouter>
    )
}